module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjE0NiIgdmlld0JveD0iMCAwIDE0NDAgMTQ2Ij4KICA8cGF0aCBmaWxsPSIjZjhmOGY4IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wLjM5MDYyNSwxNzczLjE1NjI1IEMxMzguMjEzNTQyLDE4MzEuNDAzNjUgMzY1LjIzOTU4MywxODI2LjQ3NjU2IDY4MS40Njg3NSwxNzU4LjM3NSBDOTk3LjY5NzkxNywxNjkwLjI3MzQ0IDEyNTAuOTQ3OTIsMTY5NS4zNjk3OSAxNDQxLjIxODc1LDE3NzMuNjY0MDYgTDE0MzkuODU1NDcsMTg1NiBMLTEuMDc4OTU3NDcsMTg1NiBMLTEuMDc4OTU3NDcsMTc3My42NjQwNiBMMC4zOTA2MjUsMTc3My4xNTYyNSBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0xNzEwKSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/WaveB.svg
// module id = 34
// module chunks = 168707334958949